import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const FormPreConfig = ({
    formRef,
    handleRecaptchaChange
}) => {
  return (
    <form name="form3" ref={formRef} className="mx-auto max-w-7xl px-4 py-6">
      <div className="w-full mx-auto p-6 shadow-lg rounded-lg">
        <h2 className="text-xl font-semibold mb-2 text-left">OCPP Credentials</h2>
        <h2 className="mb-10 text-left">Please enter all credentials needed for us to connect to your backend.</h2>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4">
          {/* Static Labels and Input Fields */}
          {[
            ["OCPP Engineer Name", "Will Smith"],
            ["OCPP Engineer Email", "wsmith@abc.com"],
            ["OCPP URL", "ws://ws.abc.com:8080/EVI/"],
            ["PATH", "/EVI/"],
            ["SSL (Enable/Disable)", "No"],
            ["PORT", "8080"],
            ["Authentication Key (if applicable)", "N/A"],
            ["CPID (OCPPID)", "See list Below"],
            ["Requested Charger to Test With", "Artemis 48a A12850004 (no screen)"],
            ["Certificate Required? (Yes/No)", "No"],
            ["SIM Carrier Brand", "1nce"],
            ["SIM Card APN and/or other SIM data needed", "iot.1nce.net"],
            ["Spark1", ""],
            ["Spark2", ""],
            ["Spark3", ""],
            ["Hampton1", ""],
            ["Hampton2", ""],
            ["Hampton3", ""],
            ["Towne1", ""],
            ["Towne2", ""],
            ["Towne3", ""],
          ].map(([label, value]) => (
            <React.Fragment key={label}>
              <div className="text-left">
                <label className="font-medium">{label}</label>
              </div>
              <div className="mb-4 sm:mb-0 sm:col-span-2">
                <input
                    name={label}
                    type="text"
                    className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                    placeholder={value}
                />
              </div>
            </React.Fragment>
            ))}
            <div className="text-left">
              <label className="font-medium">Comments/Instructions</label>
            </div>
            <div className="sm:col-span-2">
              <textarea
                id="comments"
                name="comments"
                rows={3}
                className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
              />
            </div>
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 mt-4">
            <div></div>
            <div className="sm:col-span-2 text-right">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleRecaptchaChange}
              /><br />
              <button type="reset" className="px-4 py-2 w-full sm:w-auto border border-gray-200 rounded-md text-white bg-black hover:bg-orange-600">
                Reset
              </button>
              &nbsp;
              <button type="submit" className="px-4 py-2 w-full sm:w-auto border border-transparent rounded-md text-white bg-orange-500 hover:bg-orange-600">
                Submit
              </button>
            </div>
        </div>
      </div>
    </form>
  );
};

export default FormPreConfig;
